import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { documentTypes, deliveryPricing } from '../../data/content';
import './PricingSection.css';

export default function PricingSection() {
  const { t } = useLanguage();
  const basePrice = Math.min(...documentTypes.map((d) => d.price));

  return (
    <section className="section pricing-section">
      <div className="container">
        <div className="section-header">
          <h2>{t.pricing.title}</h2>
          <p>{t.pricing.subtitle}</p>
        </div>

        <div className="pricing-highlight card">
          <div className="pricing-from">
            <span>{t.pricing.from}</span>
            <strong>{basePrice}</strong>
            <span>{t.pricing.perPage}</span>
          </div>
          <Link to="/order" className="btn btn-primary">{t.pricing.cta}</Link>
        </div>

        <div className="pricing-table-wrapper">
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Pages</th>
                <th>{t.pricing.standard}</th>
                <th>{t.pricing.express}</th>
                <th>{t.pricing.urgent}</th>
              </tr>
            </thead>
            <tbody>
              {deliveryPricing.map((row) => (
                <tr key={row.pages}>
                  <td>{row.pages}</td>
                  <td>{row.standard}</td>
                  <td>{row.express}</td>
                  <td>{row.urgent}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="pricing-note">{t.pricing.note}</p>
      </div>
    </section>
  );
}
